// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KZgxT","type":"styles_type__2NLj6","choices":"styles_choices__13ipf"};